import { addSchemeToUrlIfEmpty, parseUrl } from "@mapmycustomers/shared/util/url";

const normalizeUrl = (url: string): undefined | URL => {
  const parsedUrl = parseUrl(addSchemeToUrlIfEmpty(url));
  if (parsedUrl) {
    if (parsedUrl.protocol === "http:") {
      // non https links are not tracking and should be converted to https, TART-20675
      parsedUrl.protocol = "https:";
    }
  }

  return parsedUrl;
};

export default normalizeUrl;
